import type { CommissionCalcRun } from '@/types';
import { formatNumber } from '@/utils';

export interface CalcRunResult {
  computed: number; skipped_existing: number; skipped_no_rate: number; errors: number;
}

const plural = (n: number, s: string) => `${n} ${s}${n === 1 ? '' : 's'}`;

export function formatCalcRunSummary(r: CalcRunResult): string {
  const parts = [`${plural(r.computed, 'commission')} calculated successfully.`];
  if (r.skipped_no_rate > 0) parts.push(`${r.skipped_no_rate} policies skipped because no commission rate was defined.`);
  if (r.skipped_existing > 0) parts.push(`${r.skipped_existing} already calculated.`);
  if (r.errors > 0) parts.push(`${plural(r.errors, 'error')}.`);
  return `Commission run completed: ${parts.join(' ')}`;
}

/** Progress line while a run is in flight. */
export function formatCalcRunProgress(run: CommissionCalcRun): string {
  if (run.status === 'queued') return 'Queued…';
  if (run.total === 0) return 'Starting…';
  return `Calculating ${formatNumber(run.processed)} of ${formatNumber(run.total)} policies…`;
}
